module.exports = __webpack_public_path__ + "static/assets/82391dde93ebea277fcd584c2164952e.svg";